import { EmailInbox } from './EmailInbox';

export default function OutgoingEmails() {
  return (<EmailInbox inboxType="outgoing"/>)
}
